/**
 * CITY(NFT) UI 상수 — 언어팩 키만 관리. 실제 문구는 i18n에서.
 * 다른 기능 수정 시 영향 없도록 이 파일만 참조.
 */
export const CITY_KEYS = {
  MODAL_TITLE: 'city_modal_title',
  MODAL_CLOSE: 'city_modal_close',
  COMING_SOON: 'city_coming_soon',
  BTN_LABEL: 'city_btn_label',
  ICON_LABEL: 'city_icon_label',
  SERIAL_NO: 'city_serial_no',
  PRICE_SPOT: 'city_price_spot',
  PRICE_STAR: 'city_price_star',
  BUY_SPOT: 'city_buy_spot',
  BUY_STAR: 'city_buy_star',
  EQUIP: 'city_equip',
  UNEQUIP: 'city_unequip',
  OWNED: 'city_owned',
  SOLD_OUT: 'city_sold_out',
  INSUFFICIENT_BALANCE: 'city_insufficient_balance',
  HISTORY_PURCHASE: 'city_history_purchase',
  HISTORY_USE: 'city_history_use',
  LOGIN_TO_USE: 'city_login_to_use',
  REMAINING_TOTAL: 'city_remaining_total',
  DETAIL_BACK: 'city_detail_back',
  DETAIL_DESC: 'city_detail_desc',
  DETAIL_GENESIS_DESC: 'city_detail_genesis_desc',
  // 구매 플로우 UX (확인 → 진행 → 결과)
  CONFIRM_TITLE: 'city_confirm_title',
  CONFIRM_MESSAGE: 'city_confirm_message',
  PURCHASING: 'city_purchasing',
  SUCCESS_MESSAGE: 'city_success_message',
  ERROR_GENERIC: 'city_error_generic',
  CONFIRM_CANCEL: 'city_confirm_cancel',
  CONFIRM_OK: 'city_confirm_ok',
  CONFIRM_CURRENT_BALANCE: 'city_confirm_current_balance',
  BTN_CRAFT: 'city_btn_craft',
  BTN_WALLET: 'city_btn_wallet',
  COMING_SOON_POPUP: 'city_coming_soon_popup',
  // Quick Equip UI
  BADGE_OWNED: 'city_badge_owned',
  BADGE_EQUIPPED: 'city_badge_equipped',
  CONFIRM_EQUIP: 'city_confirm_equip',
  CONFIRM_UNEQUIP: 'city_confirm_unequip',
  // Slots
  SLOT_TITLE: 'city_equip_slot_title',
  ACTIVE_BONUS: 'city_active_bonus',
  SLOT_UNLOCK_CONFIRM: 'city_slot_unlock_confirm',
  SLOT_UNLOCKED: 'city_slot_unlocked',
  SLOT_NONE: 'city_slot_none',
  BTN_EQUIP_SLOT: 'city_btn_equip_slot',
  // Benefits
  BENEFIT_TITLE: 'city_benefit_title',
  BENEFIT_SPOT_10: 'city_benefit_spot_10',
  BENEFIT_SPOT_5: 'city_benefit_spot_5',
  BENEFIT_FEE_20: 'city_benefit_fee_20',
  BENEFIT_RESERVE: 'city_benefit_reserve',
  /** CITY 상세·카드 수량 라벨 (언어팩) */
  MY_SERIAL_LABEL: 'city_my_serial_label',
  TOTAL_SUPPLY_LABEL: 'city_total_supply_label',
  REMAINING_LABEL: 'city_remaining_label',
  /** 숫자+단위 (예: EN "{{count}}", KO "{{count}}개") */
  NFT_COUNT_FORMATTED: 'city_nft_count_formatted',
  /** 목록 카드 한 줄: "남은 97" / "97 left" */
  CARD_REMAINING: 'city_card_remaining',
  UNEQUIP_WITH_SLOT: 'city_unequip_with_slot',
  // STAR형 CITY 1인 1개 제한 (거래소 카니발·법적 리스크 방지, 2026-07-09)
  STAR_LIMIT_BADGE: 'city_star_limit_badge',
  // 내부 거래소 접점 (판매 등록/취소는 CityModal에서, 매물 조회·구매는 별도 MarketModal에서)
  MARKET_SELL_BTN: 'city_market_sell_btn',
  MARKET_LISTED_BADGE: 'city_market_listed_badge',
  MARKET_CANCEL_BTN: 'city_market_cancel_btn',
  MARKET_LIST_TITLE: 'city_market_list_title',
  MARKET_LIST_PRICE_LABEL: 'city_market_list_price_label',
  MARKET_LIST_PRICE_PLACEHOLDER: 'city_market_list_price_placeholder',
  MARKET_LIST_SUBMIT: 'city_market_list_submit',
  MARKET_CANCEL_CONFIRM_TITLE: 'city_market_cancel_confirm_title',
  MARKET_CANCEL_CONFIRM_MESSAGE: 'city_market_cancel_confirm_message',
  MARKET_LIST_SUCCESS: 'city_market_list_success',
  MARKET_CANCEL_SUCCESS: 'city_market_cancel_success',
  MARKET_ERROR_UNEQUIP_FIRST: 'city_market_error_unequip_first',
  MARKET_ERROR_INVALID_PRICE: 'city_market_error_invalid_price',
  GRADE_ALL: 'city_grade_all',
  GRADE_SPECIAL: 'city_grade_special',
  GRADE_MAJOR: 'city_grade_major',
  GRADE_STANDARD: 'city_grade_standard',
  GRADE_EMPTY: 'city_grade_empty'
};

/** 목록 등급. 스페셜은 제네시스, 메이저는 기존 10도시, 나머지는 스탠다드. */
export const CITY_GRADE = {
  ALL: 'all',
  SPECIAL: 'special',
  MAJOR: 'major',
  STANDARD: 'standard'
};

export const MAJOR_CITY_IDS = [
  'city_seoul',
  'city_newyork',
  'city_berlin',
  'city_hongkong',
  'city_beijing',
  'city_hanoi',
  'city_paris',
  'city_singapore',
  'city_taipei',
  'city_capetown'
];

const MAJOR_CITY_ID_SET = new Set(MAJOR_CITY_IDS);
const CITY_GRADE_RANK = {
  [CITY_GRADE.SPECIAL]: 0,
  [CITY_GRADE.MAJOR]: 1,
  [CITY_GRADE.STANDARD]: 2
};

export function getCityGrade(cityId) {
  if (cityId === 'city_genesis') return CITY_GRADE.SPECIAL;
  if (MAJOR_CITY_ID_SET.has(cityId)) return CITY_GRADE.MAJOR;
  return CITY_GRADE.STANDARD;
}

/** 전체 목록 노출 순서: 스페셜, 메이저, 스탠다드. 같은 등급은 기존 순서를 유지한다. */
export function sortCitiesByGrade(cities) {
  return [...(cities || [])]
    .map((city, index) => ({ city, index }))
    .sort((a, b) => {
      const rank = CITY_GRADE_RANK[getCityGrade(a.city.id)] - CITY_GRADE_RANK[getCityGrade(b.city.id)];
      return rank !== 0 ? rank : a.index - b.index;
    })
    .map((item) => item.city);
}

export const CITY_SLOTS = 3;
export const CITY_SLOT_UNLOCK_PRICES = [0, 10000, 30000]; // STAR array per slot (0-indexed)

/** API 폴백 시 이미지 URL이 없을 때 사용 (Static JSON과 동일 소스). CITY 이미지 미표시 방지 */
const ASSETS_BASE = 'https://assets.spot.painori.com/nft';
export const DEFAULT_CITY_IMAGE_URLS = {
  city_genesis: { imageUrl: `${ASSETS_BASE}/city_genesis.png`, thumbnailUrl: `${ASSETS_BASE}/city_genesis_thumb.png` },
  city_seoul: { imageUrl: `${ASSETS_BASE}/city_seoul.png`, thumbnailUrl: `${ASSETS_BASE}/city_seoul_thumb.png` },
  city_newyork: { imageUrl: `${ASSETS_BASE}/city_newyork.png`, thumbnailUrl: `${ASSETS_BASE}/city_newyork_thumb.png` },
  city_berlin: { imageUrl: `${ASSETS_BASE}/city_berlin.png`, thumbnailUrl: `${ASSETS_BASE}/city_berlin_thumb.png` },
  city_hongkong: { imageUrl: `${ASSETS_BASE}/city_hongkong.png`, thumbnailUrl: `${ASSETS_BASE}/city_hongkong_thumb.png` },
  city_beijing: { imageUrl: `${ASSETS_BASE}/city_beijing.png`, thumbnailUrl: `${ASSETS_BASE}/city_beijing_thumb.png` },
  city_hanoi: { imageUrl: `${ASSETS_BASE}/city_hanoi.png`, thumbnailUrl: `${ASSETS_BASE}/city_hanoi_thumb.png` },
  city_paris: { imageUrl: `${ASSETS_BASE}/city_paris.png`, thumbnailUrl: `${ASSETS_BASE}/city_paris_thumb.png` },
  city_singapore: { imageUrl: `${ASSETS_BASE}/city_singapore.png`, thumbnailUrl: `${ASSETS_BASE}/city_singapore_thumb.png` },
  city_taipei: { imageUrl: `${ASSETS_BASE}/city_taipei.png`, thumbnailUrl: `${ASSETS_BASE}/city_taipei_thumb.png` },
  city_capetown: { imageUrl: `${ASSETS_BASE}/city_capetown.png`, thumbnailUrl: `${ASSETS_BASE}/city_capetown_thumb.png` },
};

/** DB 미연결/게스트용 기본 도시 목록 — 제네시스 먼저, 기능 동작 확인용 */
export const DEFAULT_CITY_CONFIG_LIST = [
  { id: 'city_genesis', maxSupply: 1000, priceSpot: null, priceStar: 31415 },
  { id: 'city_seoul', maxSupply: 1000, priceSpot: 2000, priceStar: null },
  { id: 'city_newyork', maxSupply: 1000, priceSpot: 2000, priceStar: null },
  { id: 'city_berlin', maxSupply: 1000, priceSpot: 2000, priceStar: null },
  { id: 'city_hongkong', maxSupply: 1000, priceSpot: 2000, priceStar: null },
  { id: 'city_beijing', maxSupply: 1000, priceSpot: 2000, priceStar: null },
  { id: 'city_hanoi', maxSupply: 1000, priceSpot: 2000, priceStar: null },
  { id: 'city_paris', maxSupply: 1000, priceSpot: 2000, priceStar: null },
  { id: 'city_singapore', maxSupply: 1000, priceSpot: 2000, priceStar: null },
  { id: 'city_taipei', maxSupply: 1000, priceSpot: 2000, priceStar: null },
  { id: 'city_capetown', maxSupply: 1000, priceSpot: 2000, priceStar: null },
];

/** 도시 ID → 언어팩 키 (도시명) */
export function getCityNameKey(cityId) {
  if (!cityId || typeof cityId !== 'string') return 'city_name_genesis';
  const suffix = cityId.replace(/^city_/, '');
  return `city_name_${suffix}`;
}

/** 도시 ID → 상세 설명 언어팩 키 */
export function getCityDescKey(cityId) {
  if (cityId === 'city_genesis') return CITY_KEYS.DETAIL_GENESIS_DESC;
  return CITY_KEYS.DETAIL_DESC;
}
